module.exports = __webpack_public_path__ + "static/media/banner_empresas.dd99403d.jpg";